import React from 'react';
import './Header.css';
import { AnimatedSection } from '../AnimatedSection';
// import GlobalMenu from '../GlobalMenu';
import { useNavigate } from 'react-router-dom';

const Header = ({ PageName, fTitle, sTitle }) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };
  return (
    <header className="header">
      {/* Top Call-to-Action Section */}
      <div className="header-cta-container">

        <div className="header-main">
          <div className="header-container">
            {/* Three Columns */}

            {/* Large GAME7 Logo */}
            <AnimatedSection>
              <div className=" hidden md:flex justify-between p-10">
                <div className="flex flex-col gap-4 w-40 cursor-pointer logo-container" onClick={handleLogoClick}>
                  {/* <img src="/header_data/img/THE TWO GREATEST WORDS IN SPORTS..svg" alt="GAME7 contact us" /> */}
                  <img src="/header_data/img/Logo Homepage.svg" alt="GAME7 contact us" />
                </div>

                <div className='flex flex-col gap-6 text-right'>
                  {/* <div className='menu-adress gap-3 flex justify-end'>
                    <div>GAME7 / {PageName} / </div><div>
                      <GlobalMenu inline={true} />
                      </div>
                  </div> */}
                  {/* <img src="/header_data/img/contact_header.png" alt="GAME7 contact us" /> */}

                  {/* <div className='text-white  text-9xl leading-none font-bold uppercase text-right'>
                    <div>{fTitle}</div><div>{sTitle}</div>
                  </div> */}
                </div>
              </div>



              <div className="flex md:hidden justify-between items-center p-6 border-b-[1px] border-white">
                {/* Logo with click */}
                <div className="w-20 cursor-pointer logo-container" onClick={handleLogoClick}>
                  <img src="/header_data/img/Logo Homepage.svg" alt="GAME7 contact us" />
                </div>

                {/* GlobalMenu */}
                <div className="mt-2">
                  {/* <GlobalMenu inline={true} /> */}
                </div>
              </div>
            </AnimatedSection>

          </div>
        </div>

      </div>
    </header>
  );
};

export default Header;
